import Label from '@/components/elements/Label/Label';
import MerchantLogo from '@/components/elements/MerchantLogo/MerchantLogo';
import Rating from '@/components/elements/redesign/Rating/Rating';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { getFooterSlots } from './helpers';
import { MPServiceCardFooter } from './shared';
import { MPMapServiceCardProps } from './types';

const linkClassName =
  'text-xl text-fg_primary line-clamp-[2] overflow-hidden text-ellipsis font-bold after:absolute after:inset-0';

const MPMapServiceCard = (props: MPMapServiceCardProps & { className?: string }) => {
  const { className = '', title, subtitle, reviewRating, ratingCount, labels, to, onClick } = props;
  const hasDiscountLabels = labels?.length > 0;

  const { upper, lower, right } = getFooterSlots(props);

  return (
    <article
      className={twMerge(
        'p-xl border-border_bold bg-bg_neutral relative block w-full rounded-xl border drop-shadow-md',
        className,
      )}>
      <div className="flex flex-col">
        {/* discounts row */}
        {hasDiscountLabels && (
          <div className="gap-xs mb-sm flex items-center">
            {labels.map((labelProps, index) => (
              <Label key={index} className="whitespace-nowrap" {...labelProps} />
            ))}
          </div>
        )}

        {/* title */}
        <div className="gap-md mb-xs flex items-center">
          <h3 className="line-clamp-[2]">
            {typeof to === 'string' ? (
              <a href={to} className={linkClassName} onClick={onClick}>
                {title}
              </a>
            ) : (
              <Link to={to} className={linkClassName} onClick={onClick}>
                {title}
              </Link>
            )}
          </h3>
          {props.merchantLogoUrl && (
            <div className="ml-auto">
              <MerchantLogo imgUrl={props.merchantLogoUrl} alt="" size="sm" />
            </div>
          )}
        </div>
        {/* place and rating row */}
        <div className="gap-md mb-sm flex items-center justify-between">
          <span className="text-fg_secondary text-l line-clamp-[1] flex-1 overflow-hidden text-ellipsis">
            {subtitle}
          </span>
          {reviewRating > 0 && (
            <Rating
              showOneStar
              ratingCount={ratingCount}
              size="md"
              showCount
              hideCountLabel
              avgRating={reviewRating}
              className="ml-auto"
            />
          )}
        </div>
      </div>

      <MPServiceCardFooter upper={upper} lower={lower} right={right} />
    </article>
  );
};

export default MPMapServiceCard;
